const $ = require('jquery');
const _ = require("underscore");
import run from '../../utilities/run';
import render from "../../utilities/render";
import LookupTable from "../../components/lookupTable/index";
import { actionOptions } from "./filter/actionOptions.js";
import { searchDropdown } from "./filter/searchDropdown.js";
import { setElementsFromScope } from '../../utilities/selectorHelpers';
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import { prepareDataToSendController, doAjax, isOnlyLookupDataUpdate } from "../../utilities/filtersutil";
import { SUCCESS_MODAL_TIMEOUT } from "../../constants";
import {handleCustomDropdownEvents} from "../../utilities/customBootstrapDropdowns";
require("./dimDivisorLookup.less");

let actionCellDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdown.html');
let actionCellDropdownItemTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdownItem.html');
let loadDimDivisorDetailsLinkHtml = require("./html/dimDivisorDetailsLink.html");

let els = {};
const elsMap = {
    exportBtn: ".export-btn"
}
let actionList = actionOptions;
const targetSelector = "#dimdivisor-lookup";

const savedViews = [
    {
        title: "Default View",
        target: "allDimdivisors",
        active: true,
        canRemove: false,
        canEdit: false,
        filters: [],
        columns: [
            {
                data: "dimStatus",
                title: "Actions",
                active: true,
                canToggle: false
            },
           {
                data: "dimName",
                title: "Name",
                active: true,
                canToggle: false
            },
            {
                data: "dimStatus",
                title: "Status",
                active: true,
                canToggle: true
            },
            {
                data: "dimMerchant",
                title: "Merchant",
                active: true,
                canToggle: true
            },
            {
                data: "modifiedDate",
                title: "Date Modified",
                active: true,
                canToggle: true
            },
            {
                data: "modifiedBy",
                title: "Modified By",
                active: true,
                canToggle: true
            },
            {
                data: "dimId",
                title: "ID",
                active: true,
                canToggle: true
            }
        ]
    }
];

run(targetSelector, (mainEl) => {
    let targetObject = "";
    const dataTableComponentData = mainEl.data("dimdivisors");
    const viewDimDetailsPageUrl =mainEl.data("view-dim-details-url");
    const portletNamespace = mainEl.data("portlet-namespace");
    const changeDimStatusUrl = mainEl.data("change-status-url");
    const filterDimDivisorsUrl = mainEl.data("filter-dimdivisor-url");
    const editDimDivisorUrl = mainEl.data("edit-dimdivisor-url");
    const isfinanceadmin = mainEl.data("isfinanceadmin");    
    let deActivateDimModal = null;
    let activateDimModal = null;
        
    //Copy the render functions for reference in the lookup table from any other lookup.js

    function renderDescription(data, type, item) {
        let result;
        let html;
        if (item.itmActive) {
            html = "<div class='q-marg-all-xs-at-md'>{%- data %}</div>";
            result = render(
                html, {
                    data: data
                }
            );
        } else {
            html = "<div class='q-marg-all-xs-at-md inactive-items'>{%- data %}</div>";
            result = render(
                html, {
                    data: data
                }
            );
        }
        return result;
    }

    function renderStatusPill(data, type, row) {
        if (data === 'Y') {
            return "<div class='q-marg-all-xs-at-md q-pill q-pill-blue q-pill-table'>Active</div>";
        } else {
            return "<div class='q-marg-all-xs-at-md q-pill q-pill-blue-border q-pill-table'>Inactive</div>";
        }
    }
    
	function renderActionWrap(data, type, row, meta) {
            let newRender;
            if(row.dimName == 'Default - All Merchants'){
            data = 'D';
            } 
            
            //This logic is to hide the actions for user with CSS role
            if(isfinanceadmin == false){
                data = 'Z';
            }
            
            let statusTarget = actionList[data];

            newRender = render(
                actionCellDropdownTemplate, {
                    list: renderActionCellList(statusTarget),
                    index: meta.row
                }
            );
            
            return newRender;
    };
	
	 function renderActionCellList(list, data, row) {
        let renderedList;
        renderedList = _(list).map((item) => {
            return render(
                actionCellDropdownItemTemplate, {
                    icon: item.icon,
                    title: item.title,
                    cls: item.cls,
                    disabled: false
                }
            );
        });
        return renderedList.join('');
    }

    function renderDetailLink(data, type, row,meta){
        return render(
            loadDimDivisorDetailsLinkHtml,
            {
              dimDivisorClassName: data,
              dimId: row.dimId,
              dimParam:'dimId',
              detailsPageUrl: viewDimDetailsPageUrl,  
              portletNameSpace: portletNamespace
            }
        );
    }

    let dimdivisorLookup = new LookupTable({
        // REQUIRED - Set a target element
        target: $("#dimdivisor-lookup-wrapper"),
        // Set a target class for min width, needs to be a "til-x" class so it doesn't interfere with mobile widths
        minWidthClass: "q-min-width-sm-til-md",
        // REQUIRED - Set which data should be visible for mobile
        mobileColumns: [

            {
                data: "dimName",
                title: "Dim Divisor Name",
                render: renderDescription,
                orderable: true,
            },
            {
                data: "dimMerchant",
                title: "Merchants"
            }
        ],
		tableSearch: true,
        newSavedViews: true,
        tableSearchInput: {
            value: (targetObject != "" ? targetObject.value[0] : "")
        },
        // REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
        tableSearchDropdown: {
            selected: (targetObject == "" ? "" : targetObject.key),
            columns: searchDropdown
        },
        // OPTIONAL: Set Saved View Array
        savedViews: savedViews,
        bulkSelect: false,
        // REQUIRED - Data Table specific settings
        dataTable: {
            // use same settings you would if you were just calling a dataTable normally
            data: dataTableComponentData.content,
            // Not required, just to show you can
            columnDefs: [
                { className: "custom-class", targets: [1] }
            ],
            // Not required, just to show you can
            order: [
                [2, 'asc'],
            ],
            columns: [
                {
                    data: "dimStatus",
                    render: renderActionWrap,
                    orderable: false,
                    class: 'dtc-action-column'
                },
                {
                    data: "dimName",
                    title: "Name",
                    render: renderDetailLink,
                    class: 'dtc-min-width-md'
                },
				{
                    data: "dimStatus",
                    title: "Status",
                    render: renderStatusPill,
                    class: 'dtc-min-width-sm'
                },
                {
                    data: "dimMerchant",
                    title: "Merchant",
                    orderable: false,
                    class: 'dtc-min-width-md'
                },
				{
                    data: "modifiedDate",
                    title: "Date Modified",               
                    class: 'dtc-min-width-sm'
                },
				{
                    data: "modifiedBy",
                    title: "Modified By",                 
                    class: 'dtc-min-width-sm'
                },
                {
                    data: "dimId",
                    title: "ID",                 
                    class: 'dtc-min-width-sm lookupDimId'
                }
                	
            ]
        },
        paginationData: dataTableComponentData.page,        
        filterModal: {
            // REQUIRED: Sets title of modal
            title: "Filter DimDivisor",
            // REQUIRED: Sets unique part of subtitle string.
            tableType: "dimdivisors"
        },
        onFetch: function () {
            let currentData = dimdivisorLookup.generateData();
            dimdivisorLookup.showLoadingOverlay();
            //Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
            if (isOnlyLookupDataUpdate(currentData)) {
                setTimeout(() => {
                    doAjax({ url: filterDimDivisorsUrl, success: filterSuccess, error: error, data: prepareDataToSendController(currentData) });
                }, SUCCESS_MODAL_TIMEOUT);
            }
            
        }
    });


$('body').on('click', '.deactivate-dimdivisor', function (e) {
    
    e.preventDefault();
    let pIndex = $(this).closest('.dropdown-menu').data('parent-index');

    // Get the row based on the parent...
    let parent = $(".dropdown-parent-" + pIndex).parents('tr');
    // Get the row data
    let row = table.row(parent);
    let deActivateDimModal = new SubmitModalFlow({
        confirmModalTitle: 'Deactivate Dim Divisor',
        modalDialogClass: "q-modal-dialog-500",
        confirmModalBody: `<div class="q-pad-all-xl">Once deactivated, this dim divisor will no longer be available for selected merchants. This dim divisor can be reactivated at any time.</div>`,
        confirmModalBtnText: 'Deactivate Dim Divisor',
        onConfirmClick: function () {
            deActivateDimModal.showLoadingModal();
            deactivatedimdivisor(row, row.data());
            function deactivatedimdivisor(row, dimdivisor) {                 
                $.ajax({
                    url: changeDimStatusUrl,
                    type: 'POST',
                    dataType: 'JSON',
                    data: {
                        dimId: dimdivisor.dimId,
                        dimStatus: 'N'                                
                    },
                    success: function (data) {                                                               
                        if (data.responseStatus === "Success") {   
                            let d = row.data();
                            d.dimId=$.trim(data.dimId);
                            d.dimStatus=$.trim(data.dimStatus);      
                            d.dimName=$.trim(data.dimName);
                            d.dimStatus=$.trim(data.dimStatus);    
                            d.modifiedDate=$.trim(data.modifiedDate);
                            d.modifiedBy=$.trim(data.modifiedBy);         
                            row.data(d).draw();          
                            deActivateDimModal.showSuccessModal();                                                     
                            setTimeout(function () {                                                        
                                deActivateDimModal.hideAllModals();                                        
                            }, window.constants.SUCCESS_MODAL_TIMEOUT);
                        } else {                           
                            deActivateDimModal.showFailureModal();
                        }
                    },
                    error: function (data) {
                        deActivateDimModal.hideAllModals();
                    }
                });
            };
        }
    });    
    deActivateDimModal.init();
    deActivateDimModal.showConfirmModal();
});


$('body').on('click', '.activate-dimdivisor', function (e) {
    e.preventDefault();
    let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
    // Get the row based on the parent...
    let parent = $(".dropdown-parent-" + pIndex).parents('tr');
    // Get the row data
    let row = table.row(parent);
    let activateDimModal = new SubmitModalFlow({
        confirmModalTitle: 'Activate Dim Divisor',
        modalDialogClass: "q-modal-dialog-500",
        confirmModalBody: `<div class="q-pad-all-xl">Once activated, this dim divisor will be available for selected merchants. This dim divisor can be deactivated at any time.</div>`,
        confirmModalBtnText: 'Activate Dim Divisor',
        onConfirmClick: function () {
            activateDimModal.showLoadingModal();
            activatedimdivisor(row, row.data());
            function activatedimdivisor(row, dimdivisor) {   
                $.ajax({                   
                    url: changeDimStatusUrl,
                    type: 'POST',
                    dataType: 'JSON',
                    data: {
                        dimId: dimdivisor.dimId,
                        dimStatus:  'Y'                               
                    },
                    success: function (data) {                                                             
                        if (data.responseStatus === "Success") {      
                            let d = row.data();
                            d.dimId=$.trim(data.dimId);
                            d.dimStatus=$.trim(data.dimStatus);      
                            d.dimName=$.trim(data.dimName);
                            d.dimStatus=$.trim(data.dimStatus);    
                            d.modifiedDate=$.trim(data.modifiedDate);
                            d.modifiedBy=$.trim(data.modifiedBy);         
                            row.data(d).draw();   
                            activateDimModal.showSuccessModal();                          
                            setTimeout(function () {                      
                             activateDimModal.hideAllModals();                                        
                            }, window.constants.SUCCESS_MODAL_TIMEOUT);
                        } else {
                            activateDimModal.showFailureModal();
                        }
                    },
                    error: function (data) {
                        activateDimModal.hideAllModals();
                    }
                });
            };
        }
    });
    activateDimModal.init();
    activateDimModal.showConfirmModal();
});

    function init() {        
        $(".lookupDimId").hide();
        //generateModals();
        //setElementsInModals();
        setElements();
        //loadDropDowns();
        bindElements();
        els.exportBtn.hide();
    }

    function setElements() {
        setElementsFromScope(els, elsMap, mainEl);
    }

    function bindElements() {         
        //On clicking the Edit on lookup, show edit form 
        $('body').on('click', '.edit-dimdivisor', function (e) {
            e.preventDefault();
            let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
            // Get the row based on the parent...
            let parent = $(".dropdown-parent-" + pIndex).parents('tr');
            // Get the row data
            let row = table.row(parent);
            let dimData = row.data();
            window.location.href = editDimDivisorUrl+'&'+ portletNamespace+ 'dimId='+ dimData.dimId +'&'+portletNamespace +'flow=edit';
        });
    }

    function filterSuccess(data) {
        let dimdivisors = data.content;
        let page = data.page;
        dimdivisorLookup.setNewData(dimdivisors);
        dimdivisorLookup.setPaginationData(page);
        dimdivisorLookup.hideLoadingOverlay();
        $(".lookupDimId").hide();
    }

    function error() {
        dimdivisorLookup.hideLoadingOverlay();
        $(".lookupDimId").hide();
    }

    dimdivisorLookup.init();
    let table = $("#dimdivisor-lookup-wrapper .data-table-component").DataTable();
    // Allow custom dropdowns to work (based on class 'overflow-dropdown'), check the template for more information;
	handleCustomDropdownEvents();
    init();    
}); 


// WEBPACK FOOTER //
// ./src/pages/dimdivisor/lookup.js